import { HeaderPage } from "@/organisms/HeaderPage"

export const HeaderDashboardPage = () => {
  return <HeaderPage titleTranslationKey="navigation.dashboard" />
}
